module.exports = __webpack_public_path__ + "static/media/internal-medicine-top.558721ed.svg";